/**
 * Normalizes a campaign name filter input: trims whitespace, empty -> null.
 */
export const normalizeCampaignFilter = (input: string): string | null => {
  return input.trim() || null;
};

/**
 * Returns true when the campaign name matches the filter prefix.
 * Mirrors the fetcher's matchesCampaignNameFilter semantics (data-fetches repo):
 * case-insensitive, trimmed, prefix match; null/empty filter matches everything.
 */
export const matchesCampaignFilter = (
  campaignName: string,
  campaignNameFilter: string | null,
): boolean => {
  const normalizedFilter = campaignNameFilter?.trim().toLowerCase();
  if (!normalizedFilter) {
    return true;
  }
  return campaignName.trim().toLowerCase().startsWith(normalizedFilter);
};
